import request from '@/utils/request'

// 登录
export function loginApi(data) {
  return request({
    url: '/login/index',
    method: 'post',
    data
  })
}
// 登出
export function logoutApi() {
  return request({
    url: '/login/logout',
    method: 'get',
  })
}
// 获取验证码
export function getCodeApi(data) {
  return request({
    url: '/login/getCode',
    method: 'post',
    data
  })
}
// 获取用户信息
export function getInfoApi() {
  return request({
    url: '/account/info',
    method: 'get'
  })
}



